export default {
  published: true,
  pro: true,
  featureRestrictionsGroup: 'automationIntegrations',
  name: 'integrately',
  title: 'Integrately',
  headline: '',
  logoUrl: '/img/integrations/integrately.svg',
  // coverUrl: '/img/integrations/integrately-cover.png',
  bgColor: '#fd6420',
  categories: ['Automation'],
  comingSoon: false,
  builtIn: true,
  url: 'https://www.integrately.com/en',
  helpUrl: 'https://help.spreadsimple.com/en/article/how-to-use-webhooks-for-automation-19majym/',
  description: `Integrately is a highly rated integration platform that offers a wide range of products 
and services to simplify automation tasks. With over 8 million ready automations 
for 1,100+ apps, Integrately makes it easy to integrate your apps in just one click. 
Whether you're a non-techie or a seasoned professional, activating automation is as simple as a few easy steps. 

The platform is trusted by over 10,000 customers and offers live chat support for any 
assistance you may need. Integrately also offers exclusive deals and packages, 
making it a cost-effective choice for your automation needs. Additionally, 
the platform provides an opportunity to earn free tasks by referring friends. 

With Integrately, you get the convenience of pre-made automations and the assurance 
of a highly rated integration platform. Say goodbye to complex automation tools 
and automate your tasks with ease using Integrately.
  `,

  formFields: [],

  actions: []
}
